import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	historyNotFullySupported: {
		id: 'polaris-ideas.idea-view.history.history-not-fully-supported',
		defaultMessage: 'History for insights and formula fields is not supported yet',
		description: 'Warning for users that history section is not fully supported yet.',
	},
});
